import { ofType } from 'redux-observable';
import {
  catchError,
  delay,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer, iif } from 'rxjs';
import { navigate } from '@reach/router';
import {
  httpMethods,
  singleFileUpload,
} from '../../../../../services/http-service';
import { UPSERT_DEPOSITO } from '../../data.const';
import {
  retrieveDepositoListAction,
  setCurrentDepositoAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const upsertDepositoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(UPSERT_DEPOSITO),
    map(({ payload }: any) => {
      const { createdAt, updatedAt, listBody, ...rest } = payload;
      if (rest.id === 'crea') {
        delete rest.id;
      }
      return { body: rest, listBody };
    }),
    tap(p => console.log(`[epic ${UPSERT_DEPOSITO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, state]) => {
      return concat(
        of(setLoaders({ depositoLoader: true, page: true })),
        defer(() =>
          from(
            singleFileUpload({
              path: `deposito`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error(p.message);
              }
              return p?.data?.result;
            }),
            switchMap(data =>
              concat(
                of(setCurrentDepositoAction(data)),
                iif(
                  () => listBody,
                  of(retrieveDepositoListAction(listBody)),
                  EMPTY
                ),
                of(null).pipe(
                  tap(() => {
                    if (body?.id) {
                      return; // do not navigate in case of edit
                    }
                    navigate(
                      `${rootConfig.app_path}/redattore/depositi-edit/${
                        data?.id || 'crea'
                      }`
                    ).then(() => null);
                  }),
                  delay(500),
                  switchMap(() =>
                    of(
                      setPopupInfo({
                        opened: true,
                        message: 'Operazione completata con successo',
                        timer: 3000,
                      })
                    )
                  )
                )
              )
            ),
            catchError(err => {
              console.error(`[epic ${UPSERT_DEPOSITO}] error`, err);
              return of(
                setPopupInfo({
                  opened: true,
                  message: 'Operazione non riuscita',
                  type: 'BAD',
                  timer: 3000,
                })
              );
            })
          )
        ),
        of(setLoaders({ depositoLoader: false, page: false }))
      );
    })
  );

export default upsertDepositoEpic;
